<script>
import { mapActions } from 'vuex'

export default {
    props: {
        item: {
            type: Object,
            required: true
        },
        readonly: {
            type: Boolean,
            default: false
        },
    },

    methods: {
        ...mapActions('cart', [
            'remove',
            'update'
        ]),
        updateQuantity(event) {
            this.update( { id: this.item.id, quantity: parseInt(event.target.value) } )
        },
        removeItem(){
            this.remove( this.item.id )
        }
    },

    render() {
        return this.$scopedSlots.default({
            removeItem: this.removeItem,
            updateQuantity: this.updateQuantity
        })
    }
}
</script>
